import React, {useState, useEffect, useContext} from 'react';
import logo from './logo.svg';
import './App.scss';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";

import {createIntl, createIntlCache} from 'react-intl';
import { IntlProvider, FormattedMessage } from 'react-intl';
import {ConfigContext} from './components/ConfigContextProvider';
import {LocaleContext} from './components/LocaleContextProvider';
import {AuthenticationContext} from './components/AuthenticationContextProvider';
import NavigationBar from './components/NavigationBar/NavigationBar';
import Library from './components/Library/Library';
import HomePage from './components/HomePage/HomePage';


//LANGUAGE
//import en from './translations/en';
//const messages={en:en};
//let messages 
function App() {

  const {locale} = useContext(LocaleContext);
  const {messages} = useContext(LocaleContext);
  const userOptions = useContext(AuthenticationContext);

  const {SETUP_URL} = useContext(ConfigContext);
  const {PRODUCTS_URL} = useContext(ConfigContext);
  
  const {navigation} = useContext(AuthenticationContext);

  const getBaseName = () => {
    //detect if lang is present
    const firstPath = window.location.pathname.split('/')[1];
    return firstPath.length===2 ? "/"+firstPath+"/3dlibrary/" : process.env.PUBLIC_URL;
  }

  const layout= (type, category, order) => {
    return (
      <>
        <NavigationBar items={navigation.items}  type={type} category={category} order={order}  />
        <Library type={type} category={category} order={order}/> 
      </>
    )
  }

  return (
        <div className="App App3DLibrary">{navigation &&
          <Router basename={`${getBaseName()}`}>
            <Switch>
              <Route exact path={`/`}>
                <HomePage to={navigation.items[0].url} />
              </Route>
              {navigation && navigation.items.map((item, i) => {
                return (
                  <Route key={`route_${i}`} path={`/${item.url}`}>
                    <Switch>
                      {(item.order && item.order.map((order, k) => {
                        return (
                          <Route exact key={`route_${i}_order_${k}`} path={`/${item.url}/${order.url}`}>
                            {layout(item, null, order)}
                          </Route>
                        )
                        }))}
                        {item.category && item.category.length >0 ?
                          <Route exact  path={`/${item.url}`}>
                            <Redirect to={`/${item.url}/${item.category[0].url}`} />
                          </Route> :
                          <Route exact  path={`/${item.url}`}>
                            {layout(item)}
                          </Route>
                        }
                      </Switch>
                    <Switch>
                      {(item.category && item.category.map((category, k) => {
                          return (
                            <Route  key={`route_cat_${i}_order_${k}`} path={`/${item.url}/${category.url}`}>
                              {category.order && category.order.length >0 ?
                                <Route exact path={`/${item.url}/${category.url}/`}>
                                  <Redirect to={`/${item.url}/${category.url}/${category.order[0].url}`} />
                                </Route>
                              : <Route exact path={`/${item.url}/${category.url}/`}>
                                  {layout(item, category, null)}
                                </Route>  }
                              <Switch>
                                {(category.order && category.order.map((order, o) => {
                                    return (
                                      <Route exact key={`route_${i}_cat_${k}_order_${o}`} path={`/${item.url}/${category.url}/${order.url}`}>
                                        {layout(item, category, order )}
                                      </Route>
                                    )
                                  }
                                  ))}
                              </Switch>
                            </Route>
                          )
                        }
                        ))}
                    </Switch>
                  </Route>
                )
              })}
            </Switch>
          </Router>}
        </div>
  );

  
}

export default App;
